import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  padding: 30px 0;
  background-color: ${colors.white};
  position: relative;
  z-index: 1;
  max-width: 100vw;
  overflow: hidden;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 700px;
    height: 700px;
    border-radius: 50%;
    background-color: ${colors.brand6Lighter};
    left: -80px;
    top: -200px;
    z-index: 1;
  }
  &::after{
    content: '';
    display: block;
    position: absolute;
    top: 60px;
    left: 0;
    width: 55%;
    height: 42%;
    background-image: url('/images/pattern-02-light.svg');
    background-repeat: repeat;
    background-position: right top;
    z-index: 2;
    @media (min-width: 992px) {
      top: 120px;
    }
  }
  .PageIntroBanner_wrapper {
    position: relative;
    z-index: 3;
  }
  .PageIntroBanner_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .PageIntroBanner_headline_line_1{
    font-size: 21px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    color: ${colors.brand1};
    text-align: center;
    position: relative;
    margin: 0 0 10px 0;
    display: block;
    @media (min-width: 992px) {
      font-size: 32px;
    }
    @media (min-width: 1200px) {
      padding: 0;
    }
  }
  .PageIntroBanner_headline_line_2 {
    font-size: 32px;
    font-weight: 600;
    line-height: 1.2;
    font-family: ${typography.Serif};
    text-align: center;
    position: relative;
    display: block;
    @media (min-width: 992px) {
      font-size: 60px;
      padding: 0 30px;
    }
    &::after {
      content: '';
      display: block;
      margin: 30px auto;
      width: 125px;
      height: 2px;
      background-color: ${colors.brand3};
      @media (min-width: 1200px) {
        margin: 30px auto;
      }
    }
  }
  .PageIntroBanner_body {
    text-align: center;
    @media (min-width: 992px) {
      padding: 0 15px 0 0;
    }
  }
`;

function PageIntroBanner({ content }) {
  return (
    <div className={styles}>
      <div className="container PageIntroBanner_wrapper">
        <div className="row justify-content-center">
          {
            (get(content, '[0].headline_line_1') || get(content, '[0].headline_line_2') || get(content, '[0].text')) &&
            <div className="col-lg-10 mx-lg-auto">
              <div className="PageIntroBanner_content">
                {
                  (get(content, '[0].headline_line_1') || get(content, '[0].headline_line_2')) &&
                  <h2 className="PageIntroBanner_heading">
                    <span className="PageIntroBanner_headline_line_1">{get(content, '[0].headline_line_1')} </span>
                    <span className="PageIntroBanner_headline_line_2">{get(content, '[0].headline_line_2')} </span>
                  </h2>
                }
                <div className="PageIntroBanner_body" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].text'))} />
                <ButtonSet buttonSetParent={get(content, '[0]')} />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageIntroBannerNoPhoto.section.js